import { createSlice } from "@reduxjs/toolkit";
import { initialPersonalizedProductsState } from "./personalizedProducts.state";
import { getPersonalizedProducts } from "./personalizedProducts.thunk";

export const personalizedProductsSlice = createSlice({
  name: "personalizedProducts",
  initialState: initialPersonalizedProductsState,
  reducers: {
    resetPersonalizedProducts: (state) => {
      state.groups = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPersonalizedProducts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getPersonalizedProducts.fulfilled, (state, action) => {
        state.status = "success";
        state.groups = action.payload;
      })
      .addCase(getPersonalizedProducts.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload ?? "Hata oluştu.";
      });
  },
});

export const { resetPersonalizedProducts } = personalizedProductsSlice.actions;
export default personalizedProductsSlice.reducer;